import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEditGallery(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-gallery',
    alias: 'factoryEditGallery',
    loader: i18nLoader,
  });
}
